import { STATUS } from "@/constants/statuses";
import { OffsetPaginationMetaEntity } from "@/entities/OffsetPaginationEntity";
import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from "@datorama/akita";
import { produce } from "immer";
import { injectable } from "tsyringe";

export interface ReviewsImagesSliderState
    extends EntityState<ReviewEntity, number>,
        ActiveState {
    paginationMeta: OffsetPaginationMetaEntity;
    status: STATUS;
}

function createInitialState(): ReviewsImagesSliderState {
    return {
        active: null,
        paginationMeta: {
            perPage: 0,
            totalCount: 0,
            currentOffset: 0,
        },
        status: STATUS.VIRGIN,
    };
}

@injectable()
@StoreConfig({ name: "review_images_slider_store", producerFn: produce })
class ReviewsImagesSliderStore extends EntityStore<ReviewsImagesSliderState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS) {
        this.update(() => ({
            status: status,
        }));
    }

    getStatus(): STATUS {
        return this.getValue().status;
    }
}

export default ReviewsImagesSliderStore;
